import { defaultAppConfig } from './default-app-config';

type AppEnvironment = 'stage' | 'dev';

interface IAppConstants {
  APP_ENVIRONMENT: AppEnvironment;
}

export const AppConstants: IAppConstants = {
  APP_ENVIRONMENT: 'stage',
};

export enum FeatureAppNames {
  MAINTENANCE = 'maintenance',
  DEFAULT = 'default',
}

export const appsUMD = {
  [FeatureAppNames.MAINTENANCE]: '/assets/maintenance/maintenance-umd.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.MAINTENANCE]: '/assets/maintenance/maintenance-commonjs.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};
